const ErrorIcon = () => {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
            <rect id="24 / Alert / Attention Stroke" width="24.000000" height="24.000000" x="0.000000" y="0.000000" />
            <path id="Union" d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.6977 13.5781L11.2977 13.5781L11.0737 10.602L11.0737 7.19995L12.9217 7.19995L12.9217 10.602L12.6977 13.5781ZM12.9217 17L11.0737 17L11.0737 15.068L12.9217 15.068L12.9217 17Z" fill="rgb(255,38,38)" fillRule="evenodd" />
        </svg>
    );
};

export default ErrorIcon;